var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BModal',{attrs:{"size":"lg","centered":"","hide-footer":"","hide-header":""},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('InvoiceSend')],1)}
var staticRenderFns = []

export { render, staticRenderFns }